import { Reminder } from "../Models";
import { baseUrl, getTokenFromLocalStorage } from "./Configuration";
import { AddReminder } from "./ReminderService";

interface IDefaultSortOrderItem {
  id: string;
  name: string;
  slotOrder: number;
  startTime: Date | null;
  endTime: Date | null;
  slotCapacity: number;
  reminders:Reminder[];
}

export async function fetchDefaultSlotOrder() {
  try {
    const response = await fetch(
      baseUrl + "/api/Showings/GetDefaultSlotOrder",
      {
        headers: {
          Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
        },
      }
    );
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error); // Add this line for debugging
    throw error;
  }
}

export async function saveDefaultSlotOrder(
  slotsOrder: IDefaultSortOrderItem[]
) {
  const url = baseUrl + "/api/Showings/SaveDefaultSlotOrder";
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
  };

  const requestBody = {
    slotsOrder: slotsOrder,
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(requestBody),
    });
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error("Failed to save appointments");
    }
    return await response.json();
  } catch (error: any) {
    throw new Error(`Error: ${error.message}`);
  }
}

export async function changeSlotOrderforAvailableAppointments(
  slotappointments: IDefaultSortOrderItem[]
) {
  const url =
    baseUrl + "/api/Showings/SaveSlotOrderForAvailableAppointments";
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
  };
  function convertToString(dateTime: Date | null) {
    if (!dateTime) return "";
    const hoursDiff = dateTime.getHours() - dateTime.getTimezoneOffset() / 60;
    const minsDiff =
      dateTime.getMinutes() - (dateTime.getTimezoneOffset() % 60);
    dateTime.setHours(hoursDiff, minsDiff);
    return dateTime.toISOString();
  }
  const requestBody = {
    slotappointments: slotappointments.map((a) => ({
      id: a.id,
      name: a.name,
      slotOrder: a.slotOrder,
      startTime: convertToString(a.startTime),
      endTime: convertToString(a.endTime),
      slotCapacity: a.slotCapacity
    })),
  };
 
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(requestBody),
    });
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error("Failed to save appointments");
    }
    // add reminder 
    var reminders:Reminder[]=[];
    for (const sp of slotappointments) {
      for (const r of sp.reminders) {
        if (r.id.length === 0 && sp.id.length>0) {
          if(r.availableAppointmentId.length===0) r.availableAppointmentId=sp.id
          r.id = "00000000-0000-0000-0000-000000000000";
          reminders.push(r);
        }
      }
    }
    reminders.length>0 && await AddReminder(reminders);
    return await response.json();
  } catch (error: any) {
    throw new Error(`Error: ${error.message}`);
  }
}
